import { render, staticRenderFns } from "./P01AddNumber.vue?vue&type=template&id=63118724&scoped=true&lang=pug"
import script from "./P01AddNumber.vue?vue&type=script&lang=js"
export * from "./P01AddNumber.vue?vue&type=script&lang=js"
import style0 from "./P01AddNumber.vue?vue&type=style&index=0&id=63118724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63118724",
  null
  
)

export default component.exports